import { render, staticRenderFns } from "./PrivacyPolicyBackButton.vue?vue&type=template&id=a743e9d8&scoped=true"
import script from "./PrivacyPolicyBackButton.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyBackButton.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyBackButton.vue?vue&type=style&index=0&id=a743e9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a743e9d8",
  null
  
)

export default component.exports